import React from "react";
import { useNavigate } from "react-router-dom";
import heroImg from "../assets/hero.png";
import lumImg from "../assets/lum.webp";
import microImg from "../assets/micro.jpeg";
import exideImg from "../assets/exide.webp";
import { background } from "@chakra-ui/react";

const Home = () => {
  const navigate = useNavigate();

  const mobileStyles = `
    <style>
      @media (max-width: 768px) {
        .hero-section {
          min-height: 70vh !important;
          padding: 1rem !important;
        }
        
        .hero-overlay {
          padding: 1.5rem !important;
          border-radius: 12px !important;
          backdrop-filter: blur(3px) !important;
        }
        
        .hero-title {
          font-size: clamp(1.5rem, 6vw, 2.2rem) !important;
          margin-bottom: 0.8rem !important;
        }
        
        .hero-description {
          font-size: clamp(0.9rem, 4vw, 1.1rem) !important;
          margin-bottom: 1.2rem !important;
        }
        
        .hero-button {
          padding: 0.6rem 1.5rem !important;
          font-size: 1rem !important;
          min-width: 180px !important;
          min-height: 44px !important;
        }
        
        .popular-section {
          padding: 2rem 1rem !important;
        }
        
        .popular-title {
          font-size: clamp(1.4rem, 5vw, 1.8rem) !important;
          margin-bottom: 1.5rem !important;
        }
        
        .cards-grid {
          grid-template-columns: 1fr !important;
          gap: 1.5rem !important;
          margin-bottom: 2rem !important;
        }
        
        .card {
          margin: 0 auto !important;
          max-width: 350px !important;
        }
        
        .card-image {
          height: 180px !important;
        }
        
        .card-content {
          padding: 1.2rem !important;
        }
        
        .card-title {
          font-size: 1.2rem !important;
        }
        
        .card-description {
          font-size: 0.9rem !important;
        }
        
        .card-list {
          font-size: 0.85rem !important;
        }
        
        .features-section {
          padding: 2rem 1rem !important;
        }
        
        .features-title {
          font-size: clamp(1.6rem, 5vw, 2rem) !important;
          margin-bottom: 2rem !important;
        }
        
        .features-grid {
          grid-template-columns: 1fr !important;
          gap: 1.5rem !important;
        }
        
        .feature-card {
          padding: 1.5rem !important;
          max-width: 350px !important;
          margin: 0 auto !important;
        }
        
        .feature-title {
          font-size: 1.2rem !important;
        }
        
        .feature-description {
          font-size: 0.9rem !important;
        }
      }
      
      @media (max-width: 480px) {
        .hero-section {
          min-height: 60vh !important;
          padding: 0.8rem !important;
        }
        
        .hero-overlay {
          padding: 1.2rem !important;
        }
        
        .popular-section {
          padding: 1.5rem 0.8rem !important;
        }
        
        .features-section {
          padding: 1.5rem 0.8rem !important;
        }
        
        .card {
          max-width: 320px !important;
        }
        
        .feature-card {
          max-width: 320px !important;
          padding: 1.2rem !important;
        }
      }
    </style>
  `;

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: mobileStyles }} />
      <main style={{ background: "#ffffff" }}>
        {/* Hero Section */}
        <section
          className="hero-section"
          style={{
            minHeight: "90vh",
            backgroundImage: `linear-gradient(rgba(17, 32, 68, 0.54), rgba(22,53,101,0.5)), url(${heroImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            color: "#fff",
            position: "relative",
            padding: "2rem",
          }}
        >
          <div
            className="hero-overlay"
            style={{
              background: "rgba(25, 26, 24, 0.31)",
              padding: "2rem",
              borderRadius: 16,
              maxWidth: 800,
              width: "100%",
              backdropFilter: "blur(5px)",
            }}
          >
            <h1
              className="hero-title"
              style={{
                fontSize: "clamp(1.8rem, 4vw, 3rem)",
                marginBottom: "1rem",
                fontWeight: "700",
                lineHeight: "1.2",
                color: "#fff",
                textShadow: "0 2px 8px rgba(22,53,101,0.3)",
              }}
            >
              Be wise, choose the right watts
            </h1>
            <p
              className="hero-description"
              style={{
                fontSize: "clamp(1rem, 2.5vw, 1.25rem)",
                marginBottom: "1.5rem",
                lineHeight: "1.6",
                color: "#ffffffff",
              }}
            >
              Smart recommendations for inverter size, batteries, and trusted buying options.
            </p>
          <div style={{ textAlign: "center" }}>
            <button
              className="hero-button"
              onClick={() => navigate("/inverter")}
              style={{
                padding: "0.75rem 2rem",
                fontSize: "1.1rem",
                fontWeight: "600",
                borderRadius: "25px",
                border: "none",
                background: "linear-gradient(135deg, #048808ff 0%, #51b856ff 25%, rgba(255,255,255,0.3) 100%)",
                color: "#fff",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
                minHeight: 48,
                minWidth: 200,
                transition: "all 0.3s ease",
                textShadow: "0 1px 2px rgba(0,0,0,0.2)",
                position: "relative",
                overflow: "hidden"
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 16px rgba(76, 175, 80, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 12px rgba(76, 175, 80, 0.3)";
              }}
            >
              Find My Inverter
            </button>
          </div>
          </div>
        </section>

        {/* Popular Inverters Section */}
        <section
          className="popular-section"
          style={{
            padding: "3rem 7rem",
            maxWidth: 1200,
            margin: "0 auto",
            background: "#ffffffff",
          }}
        >
          <h2
            className="popular-title"
            style={{
              textAlign: "center",
              marginBottom: "2rem",
              color: "rgba(13, 15, 14, 0.91)", 
              fontSize: "clamp(1.7rem, 3.5vw, 2.2rem)",
              fontWeight: "700",
            }}
          >
            Popular Inverters
          </h2>

          <div
            className="cards-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "2rem",
              marginBottom: "3rem",
            }}
          >
            {/* Luminous Inverter Card */}
            <div
              className="card"
              style={{
                background: "#fff",
                borderRadius: 12,
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(22,53,101, 0.08)",
                border: "1px solid #e5e7eb",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="card-image" style={{ height: 220, overflow: "hidden" }}>
                <img
                  src={lumImg}
                  alt="Luminous Inverter"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="card-content" style={{ padding: "1.5rem", flex: 1 }}>
                <h3
                  className="card-title"
                  style={{
                    margin: "0 0 0.75rem 0",
                    color: "rgba(3, 3, 3, 0.91)", 
                    fontSize: "1.3rem",
                    fontWeight: "600",
                  }}
                >
                  Luminous Inverter
                </h3>
                <p
                  className="card-description"
                  style={{
                    margin: "0 0 1rem 0",
                    color: "#0e0e0fff",
                    fontSize: "0.95rem",
                    lineHeight: "1.5",
                  }}
                >
                  Reliable power backup solution trusted by thousands of households.
                </p>
                <ul
                  className="card-list"
                  style={{
                    paddingLeft: "1.2rem",
                    color: "rgba(9, 135, 66, 0.91)", 
                    fontSize: "0.9rem",
                    lineHeight: "1.6",
                    margin: 0,
                  }}
                >
                  <li>Capacity: 900VA – 1500VA options</li>
                  <li>Supports both flat plate and tubular batteries</li>
                  <li>Low harmonic distortion for silent operation</li>
                  <li>Ideal for medium-sized homes</li>
                </ul>
              </div>
            </div>

            {/* Microtek Inverter Card */}
            <div
              className="card"
              style={{
                background: "#fff",
                borderRadius: 12,
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(22,53,101, 0.08)",
                border: "1px solid #e5e7eb",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="card-image" style={{ height: 220, overflow: "hidden" }}>
                <img
                  src={microImg}
                  alt="Microtek Inverter"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="card-content" style={{ padding: "1.5rem", flex: 1 }}>
                <h3
                  className="card-title"
                  style={{
                    margin: "0 0 0.75rem 0",
                    color: "rgba(3, 3, 3, 0.91)", 
                    fontSize: "1.3rem",
                    fontWeight: "600",
                  }}
                >
                  Microtek Inverter
                </h3>
                <p
                  className="card-description"
                  style={{
                    margin: "0 0 1rem 0",
                    color: "#0e0e0fff",
                    fontSize: "0.95rem",
                    lineHeight: "1.5",
                  }}
                >
                  High efficiency power conversion with advanced technology.
                </p>
                <ul
                  className="card-list"
                  style={{
                    paddingLeft: "1.2rem",
                    color: "rgba(9, 135, 66, 0.91)",
                    fontSize: "0.9rem",
                    lineHeight: "1.6",
                    margin: 0,
                  }}
                >
                  <li>Capacity: 1100VA – 2000VA</li>
                  <li>Pure sine wave output for sensitive appliances</li>
                  <li>Energy-efficient with low electricity consumption</li>
                  <li>Best for small to medium homes and offices</li>
                </ul>
              </div>
            </div>

            {/* Exide Inverter Card */}
            <div
              className="card"
              style={{
                background: "#fff",
                borderRadius: 12,
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(22,53,101, 0.08)",
                border: "1px solid #e5e7eb",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="card-image" style={{ height: 220, overflow: "hidden" }}>
                <img
                  src={exideImg}
                  alt="Exide Inverter"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="card-content" style={{ padding: "1.5rem", flex: 1 }}>
                <h3
                  className="card-title"
                  style={{
                    margin: "0 0 0.75rem 0",
                    color: "rgba(3, 3, 3, 0.91)", 
                    fontSize: "1.3rem",
                    fontWeight: "600",
                  }}
                >
                  Exide Inverter
                </h3>
                <p
                  className="card-description"
                  style={{
                    margin: "0 0 1rem 0",
                    color: "#0e0e0fff",
                    fontSize: "0.95rem",
                    lineHeight: "1.5",
                  }}
                >
                  Trusted brand offering durability and superior backup performance.
                </p>
                <ul
                  className="card-list"
                  style={{
                    paddingLeft: "1.2rem",
                    color: "rgba(9, 135, 66, 0.91)",
                    fontSize: "0.9rem",
                    lineHeight: "1.6",
                    margin: 0,
                  }}
                >
                  <li>Capacity: 1000VA – 2200VA</li>
                  <li>Excellent battery management system</li>
                  <li>Quick charging with advanced DSP technology</li>
                  <li>Long life, low maintenance inverter</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section
          className="features-section"
          style={{
            padding: "3rem 7rem",
            maxWidth: 1200,
            margin: "0 auto",
            textAlign: "center",
            background: "#ffffffff",
          }}
        >
          <h2
            className="features-title"
            style={{
              fontSize: "clamp(1.9rem, 4vw, 2.5rem)",
              marginBottom: "2.5rem",
              color: "#000000ff",
              fontWeight: "700",
            }}
          >
            Why Choose WattWise?
          </h2>

          <div
            className="features-grid"
            style={{
              display: "grid",
              gap: "2rem",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            }}
          >
            <div
              className="feature-card"
              style={{
                background: "#fff",
                padding: "2rem",
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(43,86,28, 0.08)",
                border: "1px solid #e5e7eb",
                height: "100%",
              }}
            >
              <h3
                className="feature-title"
                style={{
                  fontSize: "1.3rem",
                  marginBottom: "0.75rem",
                  color: "rgba(9, 135, 66, 0.91)",
                  fontWeight: "600",
                }}
              >
                Smart Recommendations
              </h3>
              <p
                className="feature-description"
                style={{
                  color: "#040404ff",
                  fontSize: "0.95rem",
                  lineHeight: "1.5",
                  margin: 0,
                }}
              >
                Get the right inverter and battery based on your household needs.
              </p>
            </div>

            <div
              className="feature-card"
              style={{
                background: "#fff",
                padding: "2rem",
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(43,86,28, 0.08)",
                border: "1px solid #e5e7eb",
                height: "100%",
              }}
            >
              <h3
                className="feature-title"
                style={{
                  fontSize: "1.3rem",
                  marginBottom: "0.75rem",
                  color: "rgba(9, 135, 66, 0.91)",
                  fontWeight: "600",
                }}
              >
                Trusted Brands
              </h3>
              <p
                className="feature-description"
                style={{
                  color: "#040404ff",
                  fontSize: "0.95rem",
                  lineHeight: "1.5",
                  margin: 0,
                }}
              >
                Only reliable and top-rated inverter brands recommended.
              </p>
            </div>

            <div
              className="feature-card"
              style={{
                background: "#fff",
                padding: "2rem",
                borderRadius: 12,
                boxShadow: "0 4px 12px rgba(43,86,28, 0.08)",
                border: "1px solid #e5e7eb",
                height: "100%",
              }}
            >
              <h3
                className="feature-title"
                style={{
                  fontSize: "1.3rem",
                  marginBottom: "0.75rem",
                  color: "rgba(9, 135, 66, 0.91)", 
                  fontWeight: "600",
                }}
              >
                Easy Buying Links
              </h3>
              <p
                className="feature-description"
                style={{
                  color: "#040404ff",
                  fontSize: "0.95rem",
                  lineHeight: "1.5",
                  margin: 0,
                }}
              >
                Direct links to trusted sellers for hassle-free purchases.
              </p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Home;
